import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-identify-buttons',
    templateUrl: './identify-buttons.component.html',
    styleUrls: ['./identify-buttons.component.css']
})
export class IdentifyButtonsComponent {

    @Input() visible: boolean = false;

    constructor(
        private utilsService: UtilsService
    ) {
    }

    get selectedFeatureData(): any {
        return this.utilsService.featureSelected;
    }

    get showOpenStreetViewButton(): boolean {
        return this.utilsService.isSelectedFeatureATMSSite();
    }

    get showOpenReportsButton(): boolean {
        return this.utilsService.isSelectedFeatureATMSSite();
    }

    openStreetView() {
        const streetView: any = document.getElementById('streetView');
        streetView.lat = this.utilsService.getAttributeValueMatchingColumnName('FN_LATITUDE');
        streetView.long = this.utilsService.getAttributeValueMatchingColumnName('FN_LONGITUDE');
        this.utilsService.openStreetView();
    }

    openReports() {
        const tmsSiteNo = this.utilsService.getAttributeValueMatchingColumnName('TMS_SITE_NO');
        const url = `${environment.appPath}/tms-sites/${tmsSiteNo}/report`;
        window.open(url);
    }

}